import { useState, useEffect, useRef, useContext } from "react";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import gregorian from "react-date-object/calendars/gregorian";
import gregorian_en from "react-date-object/locales/gregorian_en";
import weekends from "react-multi-date-picker/plugins/highlight_weekends";
import { Grid } from "@mui/material";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { LocaleContext } from "../../../routing/LangRouter";
import { convertToGregorian } from "../../../utils/date";
import BaseTextField from "../base-text-field/base-text-field";
import { ArrowLeft2, ArrowRight2 } from "iconsax-react";
import { IS_MOBILE } from "../../../constants/breakpoints";

//import styles
import "./single-date-picker.scss";

export default function SingleDatePicker({
    dir,
    label,
    name,
    size,
    isPersianCalendar,
    handleChange,
    defaultValue,
    minDate,
    maxDate,
    onlyMonth = false,
    format,
    control,
    register,
    errors,
}) {
    //general variables
    const { locale } = useContext(LocaleContext);
    const { t } = useTranslation();
    const [selectedDate, setSelectedDate] = useState(defaultValue || null);

    //close date picker
    const datePickerRef = useRef();

    // set default value
    useEffect(() => {
        setSelectedDate(defaultValue || null);
    }, [defaultValue]);

    // Week day names in Persian (fa) and English (en)
    const weekDays = {
        fa: ["ش", "ی", "د", "س", "چ", "پ", "ج"],
        en: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    };

    // Renders navigation arrow buttons for the date picker
    const renderDateButton = (direction, handleClick) => {
        const ArrowIcon = direction === "right" ? ArrowRight2 : ArrowLeft2;
        const shouldFlipArrow = isPersianCalendar;
        return (
            <span className="dates-container__date-button" onClick={handleClick}>
                <ArrowIcon color="var(--teal-color-18)" style={{ transform: shouldFlipArrow ? "rotate(180deg)" : "none" }} />
            </span>
        );
    };

    return (
        <Grid className="single-date-picker" container item xs={12}>
            <Controller
                control={control}
                name={name}
                rules={register || ""}
                render={({ field: { onChange, value } }) => (
                    <DatePicker
                        className={`base-date-picker ${!onlyMonth || IS_MOBILE ? "rmdp-mobile" : ""} `}
                        calendar={isPersianCalendar ? persian : gregorian}
                        locale={isPersianCalendar ? persian_fa : gregorian_en}
                        weekDays={weekDays[isPersianCalendar ? "fa" : "en"]}
                        calendarPosition="bottom-right"
                        ref={datePickerRef}
                        arrow={false}
                        value={selectedDate}
                        onChange={newDate => {
                            onChange(isPersianCalendar ? convertToGregorian(newDate)?.toISOString().split("T")[0] : newDate.format("YYYY-MM-DD"));
                            setSelectedDate(newDate);
                            !register && handleChange?.(newDate);
                        }}
                        minDate={minDate}
                        maxDate={maxDate}
                        onlyMonthPicker={onlyMonth}
                        format={format}
                        render={(value, openCalendar) => {
                            return (
                                <Grid container item xs={12} rowGap={1} justifyContent="space-between">
                                    <BaseTextField
                                        dir={dir}
                                        label={label}
                                        type="text"
                                        name="departureDate"
                                        value={value}
                                        onFocus={openCalendar}
                                        size={size || "small"}
                                        radius="10px"
                                        readOnly={true}
                                        error={errors}
                                    />
                                </Grid>
                            );
                        }}
                        renderButton={renderDateButton}
                        plugins={[weekends(isPersianCalendar ? [6] : [-1, 0])]}
                        mobileLabels={{
                            OK: `${t("confirmation")}`,
                            CANCEL: `${t("close")}`,
                        }}
                    />
                )}
            />
        </Grid>
    );
}
